export default (state= [], action) => {
    switch (action.type){
        case 'FETCH_MARKET_SELECTED':
            return action.payload;
        default:
            return state;
    }
};